import React, { useEffect, useState } from "react";
import ModalBox from "../../../Components/common/ui/ModalBox";
import { fetchData } from "../../../Components/common/utils";
import { NavLink } from "react-router-dom";
const Our_Services = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModalBox, setShowModalBox] = useState(false);
  const [modalDescription, setModalDescription] = useState("");

  useEffect(() => {
    const fetchApiData = async () => {
      const url = "api/service";
      const result = await fetchData(url);
      if (result) {
        setData(result.data);
      }
      setLoading(false);
    };
    fetchApiData();
  }, []);
  const OpenMoreDetail = (id) => {
    const finddata = data.find(item => item.id === id);
    setModalDescription(finddata.description)
    setShowModalBox(true)
  }
  // console.log(data)
  if (loading) {
    return <div className="container">
      <h1 className="text-center p-4 my-4">Our Services</h1>
      <div className="row">
        <div className="col-md-6 col-sm-12 mb-2" >
          <div className="placeholder-glow">
            <span style={{ height: '10em' }} className="col-12 placeholder"></span>
          </div>
        </div>
        <div className="col-md-6 col-sm-12 mb-2" >
          <div className="placeholder-glow">
            <span style={{ height: '10em' }} className="col-12 placeholder"></span>
          </div>
        </div>
        <div className="col-md-6 col-sm-12 mb-2" >
          <div className="placeholder-glow">
            <span style={{ height: '10em' }} className="col-12 placeholder"></span>
          </div>
        </div>
        <div className="col-md-6 col-sm-12 mb-2" >
          <div className="placeholder-glow">
            <span style={{ height: '10em' }} className="col-12 placeholder"></span>
          </div>
        </div>
      </div>
    </div>
  }

  return (
    <>
      <section className=" pb-5">
        <div className="container">
          <div className="row text-center">
            <h1 className="mt-5">Our Services</h1>
          </div>
          <div className="our-service-card-wrapper mt-5">
            {data.slice(0, 5).map((details, index) => (
              <div className="" key={index}>
                <NavLink className='text-black' to={`/our-services/${details.slug}`}  >
                  <div className="d-flex h-100 cardd rounded Offering justify-content-start align-items-center gap-3 p-3">
                    {details.media.length > 0 ? (
                      <img
                        src={details.media[0].original_url}
                        alt={details.name}
                        className="services-img"
                      />
                    ) : (
                      <div className="spinner-border theme-clr" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                    <div>
                      <h5 className="mb-2">{details.title}</h5>
                      <p className="truncate-3">{details?.description}</p>
                      {/* <div className="d-flex flex-column  cursor-pointer">
                      <NavLink className="link" to={`/service-detail/${details.id}`}  >Read More</NavLink>
                    </div> */}
                    </div>
                  </div>
                </NavLink>
              </div>
            ))}
          </div>
          <div className="text-center mt-4">
            <NavLink to="/our-services" className="btn btn-danger">
              View All Services
            </NavLink>
          </div>
        </div>
      </section>
      <ModalBox
        showModalBox={showModalBox}
        setShowModalBox={setShowModalBox}
        heading={"Description"}
        description={modalDescription}
      />
    </>
  );
};

export default Our_Services;
